<sm-options-content-layout optionsWidthClass="width300" contentStyleClass="flex-col width100p">
    <ng-template #options>
        <p-panel class="height100p full-height flex-col" [header]="app.t('ProjectPlanning.options')">
            <p-tree #treeElement class="flex-item-fill height400p full-height mb-1" [value]="treeData.items" selectionMode="checkbox" [filter]=true filterBy="label" [(selection)]="treeData.selected" (selectionChange)="debouncedCalendarsChanged()">
            </p-tree>
            <sm-form class="flex-item-fixed mt-3" [form]="form"></sm-form>
        </p-panel>
    </ng-template>

    <ng-template #content>
        <div class="width100p flex-col height100p">
            <div class="flex-item-fill flex-col height100p">
                <app-project-toolbar [calendarWrapper]="calendarWrapper">
                </app-project-toolbar>
                <full-calendar #fc class="width100p height100p flex-item-fill pp-fullcal" [options]="calendarWrapper.options"></full-calendar>
            </div>
        </div>
    </ng-template>
</sm-options-content-layout>
